import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-27e4348e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "limits",
  class: "identification"
}
const _hoisted_2 = { class: "identification_wrapper" }
const _hoisted_3 = { class: "identification_second_lvl identification_lvls" }
const _hoisted_4 = { class: "top_title" }
const _hoisted_5 = { class: "middle_info_box" }
const _hoisted_6 = { class: "payment_details" }
const _hoisted_7 = { class: "payment_box" }
const _hoisted_8 = { class: "limit-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "20,000 EUR", -1))
const _hoisted_10 = { class: "limit-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "20,000 EUR", -1))
const _hoisted_12 = { class: "limit-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "500 EUR", -1))
const _hoisted_14 = { class: "limit-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "2,500 EUR", -1))
const _hoisted_16 = { class: "limit-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "5,000 EUR", -1))
const _hoisted_18 = { class: "limit-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "20,000 EUR", -1))
const _hoisted_20 = { class: "limit-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "80,000 EUR", -1))
const _hoisted_22 = { class: "limit-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "20,000 EUR", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$localization.getTranslate("Limits")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", null, "POS " + _toDisplayString(_ctx.$localization.getTranslate("SingleTransactionLimit")), 1),
                _hoisted_9
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", null, "POS " + _toDisplayString(_ctx.$localization.getTranslate("DailySpendLimitTrPerDay")), 1),
                _hoisted_11
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", null, "ATM " + _toDisplayString(_ctx.$localization.getTranslate("SingleWithdrawalLimit")), 1),
                _hoisted_13
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", null, "ATM " + _toDisplayString(_ctx.$localization.getTranslate("DailyWithdrawalLimitTrPerDay")), 1),
                _hoisted_15
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("DailyLoadLimitTrPerDay")), 1),
                _hoisted_17
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("MonthlyLoadLimit")), 1),
                _hoisted_19
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("YearlyLoadLimit")), 1),
                _hoisted_21
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("MaximumCardBalance")), 1),
                _hoisted_23
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}